var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-for-com-item",style:(_vm.comStyle)},[_vm._t("default",null,{"item":_vm.item,"index":_vm.index})],2)}
var staticRenderFns = []

export { render, staticRenderFns }